import FormService from '@/services/FormService';

export default {
  namespaced: true,
  state: {
    list: null,
    listSorted: null,
  },
  mutations: {
    m_list(state: any, list: any) {
      state.list = list;
    },
    m_listSorted(state: any, list: any) {
      state.listSorted = list;
    },
  },
  actions: {
    async a_init_Form({ dispatch }: any) {
      await dispatch('a_get_list');
    },
    async a_get_list({ commit }: any) {
      await FormService.getList().then((res: any) => {
        if (res.status === 200) {
          commit('m_list', res.data);
        }
      });
    },
    async a_get_listSorted({ commit }: any, { month, year }: any) {
      await FormService.getListByMonthAndYear({ month, year }).then((res: any) => {
        if (res.status === 200) {
          commit('m_list', res.data);
        }
      });
    },
    async a_put_updateStatus({ dispatch }: any, { params }: any) {
      await FormService.updateStatus(params).then((res: any) => {
        if (res.status === 200) {
          console.log(res.data);
          // commit('m_list', res.data);
          dispatch('a_get_list');
        }
      });
    },
  },
  getters: {
    list: (state: any) => state.list,
    listSorted: (state: any) => state.listSorted,
  },
};
